import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Grid, Skeleton } from "@mui/material";
import ChooseCab from "pages/chooseCab/ChooseCab";
import CommonRideTab from "pages/commonRideInfo/CommonRideTab";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import { tripEnumObject } from "utils/enumObject";

function BookACab(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const placeDetailLoader = useSelector((state) => state.userPlaceDetails?.loading);
  const directionLoader = useSelector((state)=> state?.userDirection?.loading);
  const locationResponse = useSelector(
    (state) => state.userLocationCheck?.userLocationCheck
  );

  const type = searchParams.get("type");
  const [isEditBtn, setIsEditBtn] = useState(false);  
  const isEdit = localStorage.getItem("isEdit");

  useEffect(() => {
    setIsEditBtn(true);
  }, [isEdit]);

 const shouldDisplayComponent =
    type === tripEnumObject?.oneWay ||
    type === tripEnumObject?.rental ||
    type === tripEnumObject?.airport ||
    (type === tripEnumObject?.outStationRound && locationResponse?.success);

  return (
    <Grid item 
    direction='column'
    className='h100p bgWhite'
     >
    <CommonRideTab
      formData={props?.formData}
      optionData={props?.optionData}
      onInputChangeVal={props?.onInputChangeVal}
      locationData={props?.locationData}
      onCurrentAddress={props?.onCurrentAddress}
      currentLat={props?.currentLat}
      currentLong={props?.currentLong}
      defaultTripValues={props?.defaultTripValues}
      btnEnable={false}
      token={props?.token}
      onSubmitBtn={props?.onSubmitBtn}
      onHandleChange={props?.onHandleChange}
      value={props?.value}
      handleTabChange={props?.handleTabChange}
      onChangeDate={props?.onChangeDate}
      currentLoader={props?.currentLoader}
      handleInput={props?.handleInput}
      airportOptionData={props?.airportOptionData}
      timeSlabData={props?.timeSlabData}
      nearbySearchData={props?.nearbySearchData}
      bufferTime={props?.bufferTime}
      noscroll={props?.noscroll}
      pageType={props?.pageType || "commonRideTab"}
    />  
    {shouldDisplayComponent && (props?.btnEnable === false || !isEditBtn) ? (
        <Grid item className='cabBg'>
          {props?.rateCalculationLoader ? (
            <Skeleton style={{ height: '300px', width: '100%' }} animation="wave" />
          ) : props?.rateCalculationData?.length > 0 ? (
            <ChooseCab
              rateCalculationData={props?.rateCalculationData}
              tripCheckoutData={props?.tripCheckoutData}
              onClickCab={props?.onClickCab}
            />
          ) : (
            <Skeleton style={{ height: '300px', width: '100%' }} animation="wave" />
          )}
        </Grid>
      ) : null}
   
  
    </Grid>
  );
}

export default BookACab;
